<template>
    <div :class="stateClasses" class="field">
        <label v-if="label" :for="name" class="field__label">
            {{ label }}
            <span v-if="required">*</span>
        </label>
        <div class="field__input-toggle">
            <input
                :name="name"
                :id="name"
                :value="newValue"
                :type="passwordFieldType"
                v-bind="$attrs"
                class="field__input"
                @input="onInput"
            />
            <div class="field__input-toggle-icon">
                <svg
                    v-if="passwordFieldType === 'password'"
                    width="18"
                    height="18"
                    viewBox="0 0 25 25"
                    @click="switchVisibility"
                >
                    <use xlink:href="../assets/feather-icons/eyes.svg#eye-open"></use>
                </svg>
                <svg v-else width="18" height="18" viewBox="0 0 25 25" @click="switchVisibility">
                    <use xlink:href="../assets/feather-icons/eyes.svg#eye-off"></use>
                </svg>
            </div>
        </div>
        <template v-if="error">
            <span class="field__message">
                <small>{{ error }}</small>
            </span>
        </template>
    </div>
</template>

<script>
export default {
    name: 'PasswordInput',
    props: {
        value: {
            type: [Number, String],
            default: null
        },
        label: {
            type: String,
            default: null,
            required: false
        },
        name: {
            type: String,
            default: '',
            required: true
        },
        required: {
            type: Boolean,
            default: false,
            required: false
        },
        error: {
            type: String,
            default: null
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            newValue: this.value,
            passwordFieldType: 'password'
        };
    },
    computed: {
        /**
         * Generate the state classes.
         *
         * @return {object}
         */
        stateClasses() {
            return {
                'has-error': this.error
            };
        }
    },
    watch: {
        /**
         * When v-model is changed:
         *   1. Set internal value.
         *   2. If it's invalid, validate again.
         *
         * @param {string} value
         */
        value(value) {
            this.newValue = value;
        },

        /**
         * Update the v-model and validate again whenever
         * internal value is changed.
         *
         * @param {string} value
         */
        newValue(value) {
            this.$emit('input', value);
        }
    },
    methods: {
        /**
         * Input's 'input' event listener, 'nextTick' is used to prevent event firing
         * before ui update, helps when using masks (Cleavejs and potentially others).
         *
         * @param {object} event
         */
        onInput(event) {
            this.$nextTick(() => {
                this.newValue = event.target.value;
            });
        },

        /**
         * Toggle input type
         */
        switchVisibility() {
            if (this.passwordFieldType === 'password') {
                this.passwordFieldType = 'text';

                return;
            }

            this.passwordFieldType = 'password';
        }
    }
};
</script>
